import { useState, useEffect } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import FilterBar from "./FilterBar";
import CourseCards from "./CourseCards";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CoursesPage = () => {
  const [allcourses, setAllCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState(0);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [category, setCategory] = useState('');
  const [subcategory, setSubcategory] = useState('');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  useEffect(() => {
      fetch(`${BASE_URL}/categories/list/`,{
          headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        }
      })
        .then((res) => res.json())
        .then((data) => setCategories(data))
        .catch((err) => console.error(err));
    }, []);
    useEffect(() => {
    fetch(`${BASE_URL}/categories/sub-list/`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        }
    })
      .then((res) => res.json())
      .then((data) => setSubcategories(data))
      .catch((err) => console.error(err));
  }, []);
  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(handler);
  }, [search]);


  useEffect(() => {
    setLoading(true);
    const url = `${BASE_URL}/courses/public?activeFilter=${activeFilter}&category=${category}&subcategory=${subcategory}&search=${debouncedSearch}`;
    // console.log("API URL:", url);

    fetch(url,{ headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        }})
      .then((res) => res.json())
      .then((data) => {
        // console.log("API Response:", data);
        setAllCourses(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching courses:", err);
        setLoading(false);
      });
  }, [activeFilter, category, subcategory, debouncedSearch]);

  return (
   
    <>
  <Header />

<div className="w-full flex  flex-col px-4 md:px-16 py-10">
  
  {/* HEADER */}
  <div className="relative z-10 mb-6  md:mb-8 text-center">
    <div className="flex items-center justify-center gap-3 mb-4">
      <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
        <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      </div>
      <h1 className="text-xl md:text-4xl font-bold text-gray-900 md:text-3xl sm:text-2xl">
        AxionNest Learning Hub
      </h1>
    </div>
    <div className="flex items-center justify-center gap-2">
      {/* <div className="w-1.5 h-6 bg-[#0f6abf] rounded-full"></div> */}
      <p className="text-gray-600 text-lg md:text-base sm:text-sm">
        Discover, learn, and grow with our educational resources
      </p>
    </div>
  </div>

  {/* FILTER BAR */}
  <FilterBar
    activeFilter={activeFilter}
    setActiveFilter={(id) => {
      setActiveFilter(id);
      setCategory('');
      setSubcategory('');
      setSearch('');
    }}
    category={category}
    setCategory={setCategory}
    subcategory={subcategory}
    setSubcategory={setSubcategory}
    search={search}
    setSearch={setSearch}
    categories={categories}
    subcategories={subcategories}
  />

  {/* COURSE CARDS */}
  <CourseCards filteredCourses={allcourses} loading={loading} />
</div>

  <Footer />
</>

  );
};

export default CoursesPage;
